// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"427":"c7f0d317","740":"5516c45d"}[chunkId] + ".css";
};